import { FC } from "react";
import { useOrgId } from "@src/common/reliablePartnerApi";
import { useAppSelector } from "@src/reduxStore";

export interface LinkToCompanyAccountProps {
  orgId?: string;
}

const LinkToCompanyAccount: FC<LinkToCompanyAccountProps> = ({
  children,
  orgId,
}) => {
  const config = useAppSelector(state => state.common.config);
  const currentOrgId = useOrgId();
  const urlOrgId = orgId || currentOrgId;

  return (
    <a
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      href={`${config?.portalUrl}/api/general/external-redirects?org_id=${urlOrgId}&sp_route=/dashboard`}
      target="_blank"
      rel="noreferrer noopener"
    >
      {children}
    </a>
  );
};

export default LinkToCompanyAccount;
